<template>
  <div class="w-full h-screen overflow-hidden bg-dark-primary relative">

    <HeaderBar />

    <div class="flex w-full pt-[50px] pb-[50px] h-full">
      <Sidebar />

      <div class="flex-1 flex flex-col overflow-hidden">
        <router-view />
      </div>
    </div>

    <footer
      class="fixed bottom-0 left-0 right-0 h-[50px] bg-dark-tertiary border-t border-dark flex items-center justify-end px-4 z-40 select-none">
      <span class="text-[10px] text-dark-tertiary font-medium tracking-wide">
        Segura Labs &copy; 2026
      </span>
    </footer>

    <div id="modal-root"></div>

    <Onboarding />

  </div>
</template>

<script setup>
import HeaderBar from "../components/HeaderBar.vue";
import Sidebar from "../components/Sidebar.vue";
import Onboarding from "../components/Onboarding.vue";
</script>